import axios from 'axios';
import { FETCH_STATE_REPORT_REQUEST, FETCH_STATE_REPORT_DATA, FETCH_STATE_REPORT_ERROR, RESET_STATE_REPORT_DATA } from './stateReportTypes';
import BASE_URL from '../config';

axios.defaults.timeout = 120000;
const timeout = 120000;

export const fetchStateReportRequest = (msg) => ({
  type: FETCH_STATE_REPORT_REQUEST,
  payload: [msg]
});

export const resetStateReportData = () => ({
  type: RESET_STATE_REPORT_DATA,
  payload: []
});

export const fetchStateReportSkanData = (campaign_list) => (dispatch, getState) => {
  dispatch(fetchStateReportRequest('loading'));
  axios({
    method: 'post',
    url: `${BASE_URL}/getSkanStateData`,
    headers: { 'Content-Type': 'application/json' },
    data: {
      userEmail: getState().userReducer.userEmail,
      CampaignIds: campaign_list,
      advertiser_id: localStorage.getItem('advertiserId'),
      sfId: localStorage.getItem('sfId'),
      startDate: getState().campaignReducer.start_date,
      endDate: getState().campaignReducer.end_date,
      timeZone: 'UTC'
    },
    timeout
  })
    .then((response) => {
      const statedata = response.data?.statedata || response.data || [];
      if (Array.isArray(statedata) && statedata.length > 0) {
        return dispatch(fetchedStateReportDetails(statedata));
      }
      return dispatch(fetchStateReportRequestError('Sorry no data found'));
    })
    .catch(() => {
      return dispatch(fetchStateReportRequestError('Not able to fetch data. Please try again'));
    });
};

export const fetchStateReportNonSkanData = (campaign_list) => (dispatch, getState) => {
  dispatch(fetchStateReportRequest('loading'));
  axios({
    method: 'post',
    url: `${BASE_URL}/getNonSkanStateData`,
    headers: { 'Content-Type': 'application/json' },
    data: {
      userEmail: getState().userReducer.userEmail,
      CampaignIds: campaign_list,
      advertiser_id: localStorage.getItem('advertiserId'),
      sfId: localStorage.getItem('sfId'),
      startDate: getState().campaignReducer.start_date,
      endDate: getState().campaignReducer.end_date,
      timeZone: getState().advertiserReducer.timeZone
    },
    timeout
  })
    .then((response) => {
      const statedata = response.data?.statedata || response.data || [];
      if (Array.isArray(statedata) && statedata.length > 0) {
        return dispatch(fetchedStateReportDetails(statedata));
      }
      return dispatch(fetchStateReportRequestError('Sorry no data found'));
    })
    .catch(() => {
      return dispatch(fetchStateReportRequestError('Not able to fetch data. Please try again'));
    });
};

export const fetchedStateReportDetails = (data) => {
  const stateReportData = data.map((item, index) => ({ id: index, ...item }));
  return {
    type: FETCH_STATE_REPORT_DATA,
    payload: stateReportData
  };
};

export const fetchStateReportRequestError = (error) => ({
  type: FETCH_STATE_REPORT_ERROR,
  payload: error
});
